/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: find out any for new consumer search data
import { renderStart } from 'shared/hocs/render'
import styled from 'styled-components'

import ConsumerFiltersSection from './NewFilters/ConsumerFiltersSection'

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ConsumerDesktopSearchFilters = ({
  filters,
  silhouettesList,
  hiddenFilters,
  isApparel,
  ssrDarwinGroup,
}: any) => {
  return (
    <FiltersWrapper>
      <ConsumerFiltersSection
        filters={filters}
        silhouettesList={silhouettesList}
        hiddenFilters={hiddenFilters}
        isApparel={isApparel}
        ssrDarwinGroup={ssrDarwinGroup}
        logSizeFilterExperiment={true}
      />
    </FiltersWrapper>
  )
}

export const NewDesktopFilters = renderStart.large(ConsumerDesktopSearchFilters)
